import { useState, useCallback } from 'react';

export function useErrorSnackbar() {
  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: ''
  });

  const openErrorSnackbar = useCallback((message = '') => {
    setErrorSnackbar((prev) => {
      if (prev.open) {
        // Prevent showing a new snackbar if one is already open
        return prev;
      }
      return { open: true, message };
    });
  }, []);

  const closeErrorSnackbar = useCallback(() => {
    setErrorSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  return {
    errorSnackbar,
    openErrorSnackbar,
    closeErrorSnackbar
  };
}
